import { render, staticRenderFns } from "./CustomLogin.vue?vue&type=template&id=2b0d5464&"
import script from "./CustomLogin.vue?vue&type=script&lang=js&"
export * from "./CustomLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports